import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=60ce6c91&scoped=true"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=60ce6c91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce6c91",
  null
  
)

export default component.exports